<template>
	<app-content class="h-panel">
		<div class="h-panel-bar">
			<span class="h-panel-title">总账</span>
		</div>
		<div class="margin-right-left margin-top">
			<!-- <account-date-choose v-model="accountDate"/> -->
			时间：<a-range-picker :locale="locale" v-model="dp"  @change="onTimeChange" />
			<!-- &nbsp;<a-radio-group v-model:value="subjectMode" button-style="solid">
				<a-radio-button value="single">单科目</a-radio-button>
				<a-radio-button value="all">多科目</a-radio-button> 
			</a-radio-group> -->
			<!-- v-if="subjectMode=='single'" -->
			&nbsp;<span  >科目：<a-select v-model="subjectId" style="width:280px" @change="subjectSelect" :options="subjectData" show-search :filter-option="filterOption" :allowClear='true'></a-select></span>
			
			<div class="float-right">
				<!-- <Checkbox v-model="showNumPrice">显示数量金额</Checkbox> -->
			</div>
		</div>
		<div class="h-panel-body margin" :space-x="10" style="overflow-x: auto;padding: 0;">
			<Loading text="总账数据加载中..." :loading="loading"></Loading>
			<table class="summary" v-if="!showNumPrice">
				<tr class="header bg-primary-color white-color">
					<td>科目编码</td>
					<td>科目名称</td>
					<td>期间</td>
					<td>摘要</td>
					<td>借方金额</td>
					<td>贷方金额</td>
					<td>方向</td>
					<td>余额</td>
				</tr>
				<template v-for="item in datalist">
					<tr class="bg-gray3-color">
						<td colspan="8">
							<span @click="toggleSummary(item)" class="text-hover">
								<i class="fa fa-caret-down" :class="{'fa-caret-right':item._expand}"></i>
								<span class="primary-color font-bold"> {{item.subject.name}}</span>
							</span>
						</td>
					</tr>
					<tr v-if="!item._expand" class="summary" v-for="s in item.summary">
						<td>{{item.subject.code}}</td>
						<td>{{item.subject.name}}</td>
						<td>{{s.voucherDate|fqFormat}}</td>
						<td>{{s.summary}}</td>
						<td align="right">{{s.debitAmount}}</td>
						<td align="right">{{s.creditAmount}}</td>
						<td align="center">{{s.balanceDirection}}</td>
						<td align="right">{{s.balance}}</td>
					</tr>
				</template>
				<tr v-if="!datalist.length">
					<td colspan="8" class="text-center padding">暂无数据</td>
				</tr>
			</table>
			<table v-else class="cus-table" style="width: 1780px;">
				<thead class="header">
				<tr>
					<td rowspan="2" width="100">科目编码</td>
					<td rowspan="2" width="100">科目名称</td>
					<td rowspan="2" width="80">单位</td>
					<td colspan="4">期初余额</td>
					<td colspan="2">本期借方</td>
					<td colspan="2">本期贷方</td>
					<td colspan="2">本年累计借方</td>
					<td colspan="2">本年累计贷方</td>
					<td colspan="4">期末余额</td>
				</tr>
				<tr>
					<td width="100">方向</td>
					<td width="100">数量</td>
					<td width="100">单价</td>
					<td width="100">金额</td>
					<td width="100">数量</td>
					<td width="100">金额</td>
					<td width="100">数量</td>
					<td width="100">金额</td>
					<td width="100">数量</td>
					<td width="100">金额</td>
					<td width="100">数量</td>
					<td width="100">金额</td>
					<td width="100">方向</td>
					<td width="100">数量</td>
					<td width="100">单价</td>
					<td width="100">金额</td>
				</tr>
				</thead>
				<tr v-for="{subject,summary} in datalist" :key="subject.id">
					<td>{{subject.code}}</td>
					<td>{{subject.name}}</td>
					<td class="text-center">{{subject.unit}}</td>
					<td class="text-center">{{summary[0].balanceDirection}}</td>
					<td class="text-right">{{summary[0].num}}</td>
					<td class="text-right">{{summary[0].price|numFormat}}</td>
					<td class="text-right">{{summary[0].balance|numFormat}}</td>
					<td class="text-right">{{summary[1].debitAmount ? summary[1].num:''}}</td>
					<td class="text-right">{{summary[1].debitAmount|numFormat}}</td>
					<td class="text-right">{{summary[1].creditAmount ? summary[1].num:''}}</td>
					<td class="text-right">{{summary[1].creditAmount|numFormat}}</td>
					<td class="text-right">{{summary[2].debitAmount ? summary[2].num:''}}</td>
					<td class="text-right">{{summary[2].debitAmount|numFormat}}</td>
					<td class="text-right">{{summary[2].creditAmount ? summary[2].num:''}}</td>
					<td class="text-right">{{summary[2].creditAmount|numFormat}}</td>
					<td class="text-center">{{summary[1].balanceDirection}}</td>
					<td class="text-right">{{summary[1].num}}</td>
					<td class="text-right">{{summary[1].price|numFormat}}</td>
					<td class="text-right">{{summary[1].balance|numFormat}}</td>
				</tr>
			</table>
		</div>
	</app-content>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
	export default {
		name: 'GeneralLedger',
		data() {
			return {
				loading: false,
				accountDate: null,
				showNumPrice: false,
				numPriceDisabled: true,
				datalist: [],
				subjectData:[],
				voucherSelect: [],
				locale,
				startTime:undefined,
				endTime:undefined,
				dp:[],
				subjectId:undefined,
				subjectMode:'all'
			};
		},
		created(){
			this.subjectLoad();
			this.loadList();
		},
		watch: {
			accountDate() {
				this.loadList();
			},
			showNumPrice() {
				this.loadList();
			}
		},
		methods: {
			filterOption(input, option) {
				return (
					option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
				);
			},
			loadList() {
				if(this.startTime==undefined ||this.startTime=='' || this.endTime==undefined || this.endTime==''){
					this.startTime = moment().startOf("month").format("YYYY-MM-DD");
					this.endTime = moment().endOf("month").format("YYYY-MM-DD");
					this.dp = [
						this.startTime,
						this.endTime
					];
				}
				this.loading = true;
				this.$api.accountbook.loadGeneralLedger2({
					startTime: this.startTime,
					endTime:this.endTime,
					showNumPrice: this.showNumPrice,
					subjectId:this.subjectId==0?undefined:this.subjectId
				}).then(({data}) => {
					this.datalist = data;
					this.loading = false;
				});
			},
			toggleSummary(item) {
				this.$set(item, '_expand', !item._expand)
			},
			//时间筛选
			onTimeChange(date, dateString){
				this.startTime = dateString[0];
				this.endTime = dateString[1];
				this.loadList();
			},
			subjectLoad() { 
				this.$api.setting.subject.voucherSelect({showAll: true}).then(({data}) => {
					this.voucherSelect = data;	
					this.$Loading.close(); 
					if(this.voucherSelect!=undefined && this.voucherSelect.length>0){
						this.subjectData.push({value:0,label:'全部'});
						for(var i = 0;i<this.voucherSelect.length;i++){
							var ops = {
								value:this.voucherSelect[i].id,
								label:this.voucherSelect[i].subjectFullName
							}
							this.subjectData.push(ops);
						}
						if(this.subjectId==undefined){
							this.subjectId=0;
						}
					}
				});
			},
			subjectSelect(val,option){
				this.loadList();
			}
		}
	};
</script>

<style scoped lang="less">
	.summary {
		width: 100%;
		border-collapse: collapse;

		td {
			padding: 0 8px;
			border: 1px solid #eee;
			font-size: 12px;
			height: 32px;
		}

		.summary:nth-child(even) {
			background-color: #f8fbf8;
		}

		.summary:hover {
			background-color: #dff7df;
		}


		.header {
			td {
				text-align: center;
				font-weight: bold;
				height: 35px;
			}
		}
	}
</style>
